import { render, staticRenderFns } from "./ColumnEditor.vue?vue&type=template&id=432e5f5c&scoped=true"
import script from "./ColumnEditor.vue?vue&type=script&lang=js"
export * from "./ColumnEditor.vue?vue&type=script&lang=js"
import style0 from "./ColumnEditor.vue?vue&type=style&index=0&id=432e5f5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e5f5c",
  null
  
)

export default component.exports